export default "__VITE_ASSET__C6IouY_Z__"